import { render, staticRenderFns } from "./edit-nivel-acceso.vue?vue&type=template&id=0d77d7ca&"
import script from "./edit-nivel-acceso.vue?vue&type=script&lang=js&"
export * from "./edit-nivel-acceso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports